/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import TopTitlePage from '../../components/TopTitlePage'
import { Button, Card, Container, Form, Offcanvas, Row } from 'react-bootstrap'
import Loading from '../../components/Loading'
import { SweetAlert } from '../../components/sweetalert'

import ReactPaginate from 'react-paginate';
import './style.css'
import { useForm } from 'react-hook-form'
import { URL } from '../../config/url'
import { useNavigate } from 'react-router-dom'
import Pacientes from '../../services/Pacientes'
import ButtonFilterAndSelect from '../../components/ButtonFilterAndSelect'
import ButtonLimparAndFiltrar from '../../components/ButtonLimparAndFiltrar'
import TableList from '../../components/TableComponents/TableList'
import TableData from './TableData'
import { isValidCPF } from '../../utilities/isValidCpf'
import { formatCPF } from '../../utilities/formatCPF'
import InputSearchName from '../../components/InputSearchName'

const ListaPacientes = () => {

  const { register, getValues, handleSubmit, reset, setValue } = useForm()
  const navigate = useNavigate()

  const [clientes, setClientes] = useState([])
  const [loading, setLoading] = useState(false)

  const [, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);

  const [show, setShow] = useState(false);
  const [filter, setFilter] = useState(false);

  useEffect(() => {
    listAllClientes(1);
  }, []);


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function listAllClientes(pageNumber) {
    setLoading(true);

    const values = getValues()

    if (values.cpf !== undefined && values.cpf !== null && values.cpf !== '') {
      values.cpf = values.cpf.replace('.', '').replace('.', '').replace('-', '').replace('/', '')
    }

    let newFiltro = {
      nome: values.nome ?? '',
      cpf: values.cpf ?? '',
      email: values.email ?? '',
      ativo: values.ativo ?? true,
    }

    Pacientes.listAllClientes(pageNumber, newFiltro)
      .then((data) => {
        setClientes(data.data.data);
        setTotalPages(data.data.paging.total_pages)
        setTotalRegistros(data.data.paging.total_records)
      })
      .catch((error) => {
        SweetAlert.error(error.response.data.message, 'Pacientes');
      })
      .finally(() => {
        // setFiltros(newFiltro)
        setLoading(false)
      });
  }

  function listFilterName(pageNumber) {
    setLoading(true);

    const values = getValues()

    let newFiltro = {
      nome: values.nome_input ?? '',
    }

    Pacientes.listAllClientes(pageNumber, newFiltro)
      .then((data) => {
        setClientes(data.data.data);
        setTotalPages(data.data.paging.total_pages)
        setTotalRegistros(data.data.paging.total_records)
      })
      .catch((error) => {
        SweetAlert.error(error.response.data.message, 'Pacientes');
      })
      .finally(() => {
        // setFiltros(newFiltro)
        setLoading(false)
      });
  }

  const handlePageChange = (selected) => {
    setPage(selected.selected + 1)
    if (getValues('nome_input') === '') {

      listFilterName(selected.selected + 1);
    } else {

      listAllClientes(selected.selected + 1);
    }
  };

  function onFilter() {

    let cpf = getValues('cpf');

    const cleanedCPF_CNPJ = cpf.replace(/\D/g, '')

    let validationFailed = false;

    if (cleanedCPF_CNPJ.length === 11 && validationFailed === false) {
      const valid = isValidCPF(cleanedCPF_CNPJ)
      if (valid === false) {
        SweetAlert.error('CPF inválido', 'CPF')
        validationFailed = true;
      }
    }

    if (validationFailed) {
      return SweetAlert.error('Informe um CPF válido', 'Filtro')
    }

    setFilter(true)


    setShow(false)
    listAllClientes(1)
  }

  function deleteClient(id) {
    setLoading(true)
    Pacientes.deleteCliente(id)
      .then((data) => {
        SweetAlert.success('Cliente deletado com sucesso!', 'Clientes');
        listAllClientes()
      })
      .catch((error) => {
        console.log(error)
        SweetAlert.error(error?.response?.data?.message, 'Clientes');
      })
      .finally(() => setLoading(false))
  }

  function deleteClientAlert(id) {
    SweetAlert.question('Atenção', 'Deletar cliente?', 'SIM!', () => deleteClient(id), '#FF0000')
  }

  function editClient(id) {
    navigate(URL.pacientes_cadastro + '/' + id)
  }

  return (
    <>
      {loading === true ? <Loading /> : ''}

      <Offcanvas show={show} onHide={handleClose} style={{ height: '100vh', backgroundColor: 'var(--app-panel-bg)' }} placement='bottom'>
        <Form onSubmit={handleSubmit(onFilter)}>
          <Container>
            <Offcanvas.Header closeButton>
              <TopTitlePage title='Filtro' />
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Card className='cardShadow'>
                <Card.Body className='p-3'>
                  <Row className='d-flex align-items-end'>
                    <Form.Group className="col-12 col-md-3">
                      <Form.Label>CPF</Form.Label>
                      <Form.Control size='sm' type="text" {...register('cpf')} onChange={(e) => formatCPF(e, setValue, 'cpf')} />
                    </Form.Group>

                    <Form.Group className="col-12 col-md-2">
                      <Form.Label>Situação</Form.Label>
                      <Form.Select {...register('ativo')} size='sm'>
                        <option value={true}>ATIVO</option>
                        <option value={false}>INATIVO</option>
                        <option value=''>TODOS</option>
                      </Form.Select>
                    </Form.Group>
                  </Row>

                  <Row className='pt-2'>
                    <Form.Group className="col-12 col-md-8">
                      <Form.Label>Nome</Form.Label>
                      <Form.Control size='sm' type="text" {...register('nome')} />
                    </Form.Group>
                  </Row>

                  <Row className='pt-2'>
                    <Form.Group className="col-12 col-md-8">
                      <Form.Label>Email</Form.Label>
                      <Form.Control size='sm' type="text" {...register('email')} />
                    </Form.Group>
                  </Row>


                </Card.Body>
              </Card>
              <div className='d-flex justify-content-end mt-3 gap-3'>
                <ButtonLimparAndFiltrar
                  handleClose={handleClose}
                  reset={reset}
                  listAll={listAllClientes}
                  setFilter={setFilter}
                />
              </div>
            </Offcanvas.Body>
          </Container>
        </Form>
      </Offcanvas>

      <div>
        <TopTitlePage title='Pacientes' />

        <div className='py-3 d-flex justify-content-between px-3 align-items-end gap-2 flex-column flex-md-row'>

          <ButtonFilterAndSelect
            handleShow={handleShow}
            listAll={listAllClientes}
            filter={filter}
          />


          <div className='d-flex align-items-end col-12 col-md-auto'>
            <Button
              variant='success'
              onClick={() => navigate(URL.pacientes_cadastro)}
              className='col-12 col-md-auto'
            >+ Novo Paciente</Button>
          </div>
        </div>

        <div className='mx-3 mb-2 lg-mb-0'>

          <InputSearchName
            register={register}
            listAll={listAllClientes}
            listFilterName={listFilterName}

          />

        </div>

        <Card className='mx-3 cardShadow mb-2 lg-mb-0' >
          <Card.Body className='p-0'>

            {clientes.length === 0 ?
              <div className='d-flex justify-content-center py-2'>
                <h4>Sem registros</h4>
              </div>
              :
              <>
                <TableList>
                  <TableData
                    array={clientes}
                    editFunction={editClient}
                    deleteFunction={deleteClientAlert}
                  />
                </TableList>


                <div className='mt-4 d-flex justify-content-between px-3 flex-column flex-md-row gap-3'>
                  <span> Total: {totalRegistros}</span>
                  <ReactPaginate
                    pageCount={totalPages}
                    pageRangeDisplayed={1}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={'pagination_container'}
                    activeClassName={'active'}
                    previousLabel={'<'}
                    nextLabel={'>'}
                  />
                </div>
              </>
            }


          </Card.Body>
        </Card>



      </div>
    </>
  )
}

export default ListaPacientes